import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import './PublicNavbar.css';

const PublicNavbar = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Navbar expand="lg" sticky="top" style={{ backgroundColor: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', borderBottom: '3px solid #55c900' }}>
      <Container>
        <Navbar.Brand href="/" className="fw-bold">
          <img width={70} src="/assets/images/bhit-logo.png" alt="BHIT Infotech" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="public-navbar" />
        <Navbar.Collapse id="public-navbar">
          <Nav className="ms-auto align-items-center" id="public-nav">
            <Nav.Link href="#about" className="nav-link-custom">
              About
            </Nav.Link>
            <Nav.Link href="#services" className="nav-link-custom">
              Services
            </Nav.Link>
            <Nav.Link as={Link} to="/internship" className="nav-link-custom">
              Internship
            </Nav.Link>
            <Nav.Link href="#contact" className="nav-link-custom">
              Contact
            </Nav.Link>
            {user && user.id ? (
              <Button 
                size="sm" 
                className="ms-2"
                style={{ 
                  backgroundColor: '#55c900', 
                  borderColor: '#55c900',
                  color: 'white',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#48b000'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#55c900'}
                onClick={() => navigate('/dashboard')}
              >
                Go to Dashboard
              </Button>
            ) : (
              <>
                <Button 
                  size="sm" 
                  className="ms-2"
                  style={{ 
                    backgroundColor: 'transparent', 
                    borderColor: '#00428a', 
                    color: '#00428a',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => { 
                    e.target.style.backgroundColor = '#00428a'; 
                    e.target.style.color = 'white'; 
                  }}
                  onMouseLeave={(e) => { 
                    e.target.style.backgroundColor = 'transparent'; 
                    e.target.style.color = '#00428a'; 
                  }}
                  onClick={() => navigate('/login')}
                >
                  Candidate Login
                </Button>
                <Button 
                  size="sm" 
                  className="ms-2"
                  style={{ 
                    backgroundColor: '#55c900', 
                    borderColor: '#55c900',
                    color: 'white',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#48b000'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#55c900'}
                  onClick={() => navigate('/register')}
                >
                  Join Our Training
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PublicNavbar;
